/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demokath_Theologie17Inputs */

const en__field_enum_demokath_theologie17 = /** @type {(inputs: _Field_Enum_Demokath_Theologie17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`07 - Katholische Theologie`)
};

const de__field_enum_demokath_theologie17 = /** @type {(inputs: _Field_Enum_Demokath_Theologie17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`07 - Katholische Theologie`)
};

/**
* | output |
* | --- |
* | "07 - Katholische Theologie" |
*
* @param {_Field_Enum_Demokath_Theologie17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demokath_theologie17 = /** @type {((inputs?: _Field_Enum_Demokath_Theologie17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demokath_Theologie17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demokath_theologie17(inputs)
	return de__field_enum_demokath_theologie17(inputs)
});
export { _field_enum_demokath_theologie17 as "_field_enum_DEMOKATH_THEOLOGIE" }